import axios from "axios";
const API_URL =
  process.env.VUE_APP_SORRY_URL || "https://api.sorryapp.com/v1/pages/e31b0d77";

export default () => {
  return axios.create({
    baseURL: API_URL,
    withCredentials: false,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    }
  });
};
